import { useLocation } from "react-router-dom";
import { Fragment } from "react";
import { ValidationMessageTypeIcon } from "../StatusIcons/ValidationMessageTypeIcon";
import { IngestionMessage, MessageScope, MessageSource } from "../asset-service-api";
import { useProjects } from "../Behaviors/projects";
import { useStore } from "../State/zustandStore";
import { getFileErrors } from "./../validation/fileValidator";

const getMessageKey =
    (
        message: IngestionMessage |
        {
            message: string;
            messageType: string;
            timeStamp?: string | undefined;
            details?: string | null | undefined;
            source?: MessageSource | undefined;
        }) => {
        return `${message.source?.id}:${message.timeStamp}:${message.source?.target}:${message.message}`;
    };

interface Props {
    projectId?: string /* The '?' makes projectId optional */
}

export const FileErrors = ({ projectId }: Props) => {
    const workspaceState = useStore().projects;
    const projId = projectId
        ? projectId
        : workspaceState.selectedProjectId;
    const { project } = useProjects(projId);
    const getTarget = (message: IngestionMessage) => {
        if (message.source?.scope === MessageScope.Resource) {
            return project?.resourceInfo?.isrc;
        }
        return message.source?.target;
    };
    const fileErrors = getFileErrors(project!);
    const reportPage = useLocation().pathname.includes(`${projectId}`);
    return (
        <>
            <h4>Other Asset Errors</h4>
            <div className={reportPage ? "outline" : ""}>
                <table className="bg-light">
                    <tbody>
                        <tr className={"shift-hidden"}>
                            <td colSpan={6}>Job Id: {project?.jobId}</td>
                        </tr>
                        {
                            fileErrors.map(message => {
                                return (
                                    <Fragment key={getMessageKey(message)}>
                                        <tr>
                                            <td className={"iconic"}>
                                                <ValidationMessageTypeIcon messageType={message.messageType!} />
                                            </td>
                                            <td className={"shift-hidden"}>
                                                {message.source?.id}
                                            </td>
                                            <td className={"shift-hidden"}>
                                                {message.source?.name}
                                            </td>
                                            <td className={"shift-hidden"}>
                                                {message.timeStamp}
                                            </td>
                                            <td style={{ width: "30%" }} >
                                                {getTarget(message as IngestionMessage)}
                                            </td>
                                            <td style={{ width: "100%" }}>
                                                {message.message}
                                            </td>
                                        </tr>
                                        {message.details ?
                                            <tr className={"shift-hidden"}><td>{message.details}</td></tr>
                                            : null}
                                    </Fragment>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        </>
    );
};
